// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// util
import { UitkList } from 'uitk-react-list';

export interface PzInfoDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  programTitle: string;
  commissionPercentage: number;
  cookieDuration: number;
}

export const PzInfoDialog: React.FunctionComponent<PzInfoDialogProps> = ({
  dialogId,
  l10n,
  routeStore,
  programTitle,
  commissionPercentage,
  cookieDuration,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const dialogHeading = 'pz.signup.info.dialog.commission.title';

  const dialogContent = (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message={dialogHeading} data={[programTitle]} />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.info.dialog.commission.paragraph1" data={[commissionPercentage]} />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText
              message="pz.signup.info.dialog.commission.paragraph2"
              data={[programTitle, cookieDuration]}
            />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.info.dialog.commission.paragraph3" />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.info.dialog.commission.paragraph4" />
          </UitkParagraph>
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzInfo" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
